import React,{Fragment} from 'react'

 const about = () => {
    return (
        <Fragment>
            <h1>About this App</h1>
            <p>App is to search Github user</p>
            <p>App Version 1.0.0</p>
        </Fragment>
    )
}
export default about;
